module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-20-3331a7ce271b709ea781dee96071042e.png";